import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api/src/common/queryFunction';

import { getBomTableQueryKey } from './keys';
import type {
  GetBomTableResponseBody,
  GetBomTableParams,
  GetBomTableQueryKeyType,
} from './types';

export const useGetBomTable: QueryFunction<
  GetBomTableResponseBody,
  [GetBomTableParams],
  GetBomTableQueryKeyType
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getBomTableQueryKey(params);

  return useQuery({
    ...queryOptions,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    queryKey,
    queryFn: ({ signal }) => {
      return request(`/quotes/components/${params.id}/bom_table/`, {
        init: {
          method: 'GET',
          signal,
        },
        query: {
          bomType: params.bomType,
          search: params.search,
          grouped: params.grouped ?? false,
        },
      });
    },
  });
};
